import { render, staticRenderFns } from "./ProductShowAddInventory.vue?vue&type=template&id=9e16edb2&"
import script from "./ProductShowAddInventory.vue?vue&type=script&lang=js&"
export * from "./ProductShowAddInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports